<kendo-dialog
  title="Delete Price Tier {{ tierToRemove.name }}"
  (close)="onCancel()"
>
  <div class="remove-tier-confirmation-message">
    <p>
      Deleting this tier will move its assigned restaurants back to unassigned.
    </p>

    <p>Are you sure you want to delete this tier?</p>
  </div>

  <kendo-dialog-actions>
    <button kendoButton (click)="onCancel()">Cancel</button>
    <button kendoButton (click)="onProceed()" themeColor="error">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>
